export enum ErrorMessages {
  PATHWAY_NAME_UNIQUENESS_VERIFICATION = 'E0001',
  GET_CURATION_ITEM_BY_KEYS = 'E0002'
}
